import alliumTheme from '@telus-uds/theme-allium'
import { BaseProvider } from '@telus-uds/components-web'

import { SiteBuilderProvider } from 'src/siteBuilder/renderer/context/SiteBuilderProvider'
import { ArticlePage } from '../components/ArticlePage'
import sitebuilderConfig from '../../../sitebuilder.config'
import { TimelinePreviewError } from '../components/TimelinePreviewError/TimelinePreviewError'
import type { MediaReleasePageProps } from './createMediaReleaseGetServerSideProps'

export default function TelusMediaReleasePage(props: MediaReleasePageProps) {
  if (props.timelinePreviewError) {
    return <TimelinePreviewError />
  }
  if (!props.articlePageTemplate) {
    return null
  }

  return (
    // @ts-ignore // TODO remove this when it's fixed in their type defs
    <BaseProvider defaultTheme={alliumTheme}>
      <SiteBuilderProvider
        currentPage={props.articlePageTemplate}
        space={sitebuilderConfig.space}
        locale={props.locale}
        isWebpSupported={true}
        brand="telus"
      >
        <ArticlePage articlePageTemplate={props.articlePageTemplate} locale={props.locale} />
      </SiteBuilderProvider>
    </BaseProvider>
  )
}
